import React, { useEffect, useState } from "react";
import "../Designs/trending.css";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { Link } from "react-router-dom";

const TrendingPages = () => {
  const [trendingMovies, setTrendingMovies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [accord, setAccord] = useState(false);
  const [visible, setVisible] = useState(8);

  useEffect(() => {
    getTrendingMovies();
  }, []);

  const getTrendingMovies = async () => {
    setIsLoading(true);
    const data = await fetch(
      "https://api.themoviedb.org/3/trending/all/day?api_key=375735221c3b7b45a786c79616eae571&language=en-US"
    );
    const response = await data.json();
    setTrendingMovies(response.results);
    setIsLoading(false);
    console.log(response.results.length, "Accord");
  };

  function showAccord(id) {
    setAccord(id);
  }

  function loadMoreHandler() {
    setVisible((prevValue) => prevValue + 5);
  }

  // useEffect(() => {
  //   if (accord === movie.id) {
  //     stopScrollForModal();
  //   } else {
  //     return;
  //   }
  // }, []);

  function stopScrollForModal() {
    return (document.body.style.overflowY = "hidden");
  }

  return (
    <>
      {isLoading && (
        <p style={{ color: "white", fontSize: 20, fontWeight: 700 }}>
          Loading...
        </p>
      )}
      {/* <div className="main-design-one">
        <p
          style={{ color: "white", fontSize: 20, fontWeight: 700 }}
        >
          Trending Movies One Should Watch
        </p>
        <Splide
          options={{
            perPage: 6,
            // type: "loop",
            drag: "free",
            perMove: 1,
            pagination: false,
            gap: "0.2rem",
            breakpoints: {
              640: {
                perPage: 2,
                width: 400,
                height: 400,
                pagination: false,
              },
              450: {
                perPage: 2,
                width: 400,
                height: 400,
                pagination: true,
                arrows: false,
              },
            },
          }}
        >
          {trendingMovies.map((movie) => (
            <SplideSlide>
              <Link key={movie.id} target="__blank" to={`/movie/${movie.id}`}>
                <div className="card-design">
                  <img
                    className="card-image"
                    src={`https://image.tmdb.org/t/p/original${movie.poster_path}`}
                    alt="movie"
                  />
                  <div className="card__content">
                    <p className="card-title">{movie.original_title}</p>
                    <p className="card_rating">
                      {" "}
                      {movie.vote_average} <i className="fa fa-star"></i>
                    </p>
                    <p className="card_desc">{movie.overview}</p>
                  </div>
                </div>
              </Link>
            </SplideSlide>
          ))}
        </Splide>
      </div> */}
      <p
        style={{
          color: "white",
          fontSize: 20,
          fontWeight: 700,
          marginBottom: "1rem",
          textAlign: "center",
        }}
      >
        Trending Movies To Watch
      </p>
      <div className="trending__box">
        {trendingMovies.slice(0, visible).map((movie) => (
          // <Link to={`/movie/${movie.id}`}>
          <div key={movie.id} className="box">
            <div className="content__box">
              <div className="image__box">
                <img
                  src={`https://image.tmdb.org/t/p/original${movie.poster_path}`}
                  alt="movie"
                />
              </div>
              <div className="title__box">
                <p>
                  {!movie.original_title
                    ? movie.original_name
                    : movie.original_title}
                </p>
              </div>
              <div className="accordion__box">
                <button onClick={() => showAccord(movie.id)}>
                  View Description
                </button>
              </div>
            </div>
            {accord === movie.id && (
              <div>
                <div
                  style={{
                    backgroundImage: `linear-gradient(to right, rgb(24, 5, 40) calc((50vw - 170px) - 340px), rgba(53, 11, 32, 0.6) 50%, rgba(39, 7, 25, 1) 100%), url(https://image.tmdb.org/t/p/original${movie.backdrop_path})`,
                    // background: `linear-gradient(to right, rgba(52.5, 10.5, 31.5, 1) calc((50vw - 170px) - 340px), rgba(52.5, 10.5, 31.5, 0.84) 50%, rgba(52.5, 10.5, 31.5, 0.84) 100%),url(https://image.tmdb.org/t/p/original${movie.backdrop_path})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                  className="backdrop"
                ></div>
                <div className="desc__box">
                  <p className="trending__overview" style={{ color: "white" }}>
                    {movie.overview}
                  </p>
                  <div className="close__visit">
                    <Link
                      className="trending__btn visit"
                      to={`/movie/${movie.id}`}
                    >
                      Visit
                    </Link>
                    <button
                      onClick={() => setAccord(!movie.id)}
                      className="trending__btn close"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          // </Link>
        ))}
      </div>
      {/* {!movie.length[-1] && ( */}
      <div className="close__visit">
        <button onClick={loadMoreHandler} className="trending__btn load">
          Load More
        </button>
      </div>
      {/* )} */}
    </>
  );
};

export default TrendingPages;
